import { useState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useLang } from "@/lib/i18n";

const EMPTY = { first_name: "", last_name: "", email: "", phone: "", message: "" };

export const InquiryForm = ({ listing, successText }) => {
  const [form, setForm] = useState(EMPTY);
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");
  const { t, lang } = useLang();
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setState("loading");
    setError("");
    try {
      await api.post("/inquiries", { ...form, message: lang === "es" ? `[ES] ${form.message}` : form.message, listing_slug: listing?.slug || "", listing_title: listing?.title || "" });
      setState("done");
      setForm(EMPTY);
    } catch (err) {
      setError(formatApiError(err));
      setState("idle");
    }
  };

  if (state === "done")
    return (
      <div className="flex items-start gap-3 rounded-xl bg-linen p-5" data-testid="inquiry-success">
        <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-forest" />
        <p className="text-sm font-semibold text-ink">{successText || t("form.success")}</p>
      </div>
    );

  const field = "h-12 rounded-lg border-clay bg-white font-medium focus-visible:ring-forest";
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="inquiry-form">
      <div className="grid grid-cols-2 gap-3">
        <Input required placeholder={t("form.first")} value={form.first_name} onChange={set("first_name")} className={field} data-testid="inquiry-first-name" />
        <Input placeholder={t("form.last")} value={form.last_name} onChange={set("last_name")} className={field} data-testid="inquiry-last-name" />
      </div>
      <Input required type="email" placeholder={t("form.email")} value={form.email} onChange={set("email")} className={field} data-testid="inquiry-email" />
      <Input placeholder={t("form.phone")} value={form.phone} onChange={set("phone")} className={field} data-testid="inquiry-phone" />
      <Textarea required rows={4} placeholder={t("form.message")} value={form.message} onChange={set("message")} className="rounded-lg border-clay bg-white font-medium focus-visible:ring-forest" data-testid="inquiry-message" />
      {error && <p className="text-sm font-semibold text-destructive" data-testid="inquiry-error">{error}</p>}
      <button type="submit" disabled={state === "loading"} className="btn-primary w-full" data-testid="inquiry-submit">
        {state === "loading" && <Loader2 className="h-4 w-4 animate-spin" />} {t("form.send")}
      </button>
    </form>
  );
};
